import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;


export function cekAuth() {
  return {
    headers: {
        Authorization: API_KEY + localStorage.getItem("token"),
        'Content-Type':'multipart/form-data'
    }
  };
}

export function fetchPeopleAll() {
  let url = `${ROOT_URL}api/profile/`;
  if (localStorage.getItem("email") != "admin@sibernetik.co.id") {
    url = `${ROOT_URL}api/profile/?search=${localStorage.getItem("company_code")}`;
  }
  const request = axios.get(url, cekAuth());
  return request;
}

export function pushPeople(body) {
    const url = `${ROOT_URL}api/profile/`;

    const fdata = new FormData();
    fdata.append('email', body.email);
    fdata.append('name', body.name);
    fdata.append('password', body.password);
    fdata.append('brithday', body.brithday);
    fdata.append('gender', body.gender);
    fdata.append('login_type','web');
    fdata.append('picture_background_url', "");
    fdata.append('picture_url', "");
    fdata.append('social_id', "");
    fdata.append('description', body.description);
    fdata.append('job', body.job);
    fdata.append('company_code', body.company_code);
    fdata.append('userlevel', body.userlevel);
    const request = axios.post(url, fdata, cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;
}

export function updatePeople(body) {
  let url = "";
  const fdata = new FormData();
  fdata.append('email', body.email);
  fdata.append('name', body.name);
  if(body.password !== ""){
    url = `${ROOT_URL}api/profile/${body.id}/`;
    fdata.append('password', body.password);
  }else{
    url = `${ROOT_URL}api/profileex/${body.id}/`;
  }
  fdata.append('brithday', moment(body.brithday).format("YYYY-MM-DD"));
  fdata.append('gender', body.gender);
  fdata.append('login_type','web');
  fdata.append('picture_background_url', "");
  fdata.append('picture_url', "");
  fdata.append('social_id', "");
  fdata.append('description', body.description);
  fdata.append('job', body.job);
  fdata.append('company_code', body.company_code);
  fdata.append('userlevel', body.userlevel);
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function deletePeople(id) {
    const url = `${ROOT_URL}api/profile/${id}/`;

    const request = axios.delete(url, cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;
}
